import { render, staticRenderFns } from "./Aggregated.vue?vue&type=template&id=4c17250b"
import script from "./Aggregated.vue?vue&type=script&lang=js"
export * from "./Aggregated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports